import Container from '@mui/material/Container';
import { H5 } from '@/components/type';
import { CURATED_FILTERS } from '@/constants/curated-filters';
import { getCuratedFilterUrl } from '@/utils/get-curated-filter-url';
import { SuggestionCard, SuggestionsContainer } from './styles';
import Icon, { iconNames } from '@/components/icons';

const CuratedFilterSuggestions = () => {
  return (
    <Container maxWidth="xl">
      <H5 as="h2">Looking for your next car? Browse safe cars for:</H5>
      <SuggestionsContainer role="list">
        {Object.entries(CURATED_FILTERS).map(([key, filter]) => (
          <SuggestionCard
            key={key}
            href={getCuratedFilterUrl(key as keyof typeof CURATED_FILTERS)}
            disableRipple
            role="listitem"
            aria-label={`Browse ${filter.title} ${filter.price}`}
          >
            {filter.title} {filter.price}
            <Icon name={iconNames.linkActive} aria-hidden="true" role="presentation" />
          </SuggestionCard>
        ))}
      </SuggestionsContainer>
    </Container>
  );
};

export default CuratedFilterSuggestions;
